import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { credit_card } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_B04_SendMoneyToCreditManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={credit_card}
  />
);

export default Sim_B04_SendMoneyToCreditManually;
